import styled from 'styled-components';
import {CSS_CONSTANTS} from '../../../css_variables';

const SignUpModalStyle = styled.div`
	min-width: 1000px;
	margin: auto;
	display: flex;
	flex-direction: row;
	justify-content: space-between;

	.right-side {
		width: 250px;
	}

	.options {
		margin-right: 20px;
		padding: 10px 20px;
		border: 1px #e4e4e4 solid;

		.plan-header {
			font-weight: 700;
			text-align: center;
			margin-bottom: 20px;
		}

		.plan-top-content {
			display: flex;
			flex-direction: row;
			margin-bottom: 20px;

			.plan-select {
				margin-right: 30px;

				.plan-option {
					display: flex;
					cursor: pointer;

					&:not(:last-child) {
						margin-bottom: 14px;
					}

					.radio-button-wrapper {
						margin-right: 5px;
					}

					.jira-warning {
						color: ${CSS_CONSTANTS.error_text_color};
						margin-left: 8px;
						margin-top: 4px;
						font-size: 12px;
					}
				}
			}

			.billing-select,
			.term-select {
				display: flex;
				flex-direction: column;
				margin-right: 30px;

				button {
					width: 140px;
					height: 32px;
				}
			}
		}

		.plan-bottom-content {
			display: flex;
			flex-direction: row;
			font-size: 14px;

			.left-section {
				margin-right: 20px;
			}

			.currency-select {
				width: 150px;
				margin-bottom: 20px;
			}

			.onboarding {
				label {
					cursor: pointer;
					input {
						margin-right: 5px;
					}
				}
			}

			.right-section {
				padding: 10px;
				border: 1px #e4e4e4 solid;
				width: 100%;

				.user-section-header {
					text-align: center;
					font-weight: 700;
				}

				.user-section {
					display: flex;
				}

				.users {
					min-width: 170px;
				}

				.users,
				.virtual-users {
					margin-right: 20px;

					label {
						width: 50%;
						.invalid-seats {
							min-height: 14px;
							font-size: 12px;
							color: ${CSS_CONSTANTS.negative_value};
						}
						.seat-wrapper {
							justify-content: space-between;
							display: flex;
							:last-child {
								align-self: center;
							}
							input {
								padding: 9px 10px;
								font-family: ${CSS_CONSTANTS.text_font_family};
								font-weight: ${CSS_CONSTANTS.base_font_medium_weight};
								text-align: center;
								border: 1px solid ${CSS_CONSTANTS.app_border_color};
								border-radius: 3px;
								width: 50px;
								height: 30px;
								margin: auto 0;
								&.invalid {
									border-color: ${CSS_CONSTANTS.negative_value};
								}
							}

							.amount-text {
								margin-right: 5px;
							}
							.amount-number {
								margin-right: 21px;
							}
						}
					}
				}
			}
		}
	}

	.receipt {
		margin-bottom: 20px;
		.total-error-text {
			color: ${CSS_CONSTANTS.negative_value};
			margin-top: 4px;
			width: 100%;
		}
		.total-change {
			color: ${CSS_CONSTANTS.positive_value};
			margin-top: 4px;
			width: 100%;
		}
	}

	.details {
		.no-top-margin {
			margin-top: 0px;
		}
		label {
			display: block;
			margin-bottom: 15px;
			> span {
				letter-spacing: 1px;
				font-weight: normal;
				font-size: 9px;
				color: $v2-text-light-gray;
				display: block;
				padding: 0 0 6px 2px;
			}
			> input {
				@include input-field;
				padding: 9px 10px;
				font-size: 12px;
				font-family: $text-font-family;
				border: 1px solid $app-border-color;
				border-radius: 3px;
				width: 100%;
			}
			.vat-wrapper {
				> input {
					@include input-field;
					padding: 9px 10px;
					font-size: 12px;
					font-family: $text-font-family;
					border: 1px solid $app-border-color;
					border-radius: 3px;
					width: 100%;
				}

				.vat-country-code {
					position: absolute;
					left: 3px;
					top: 1px;
					text-align: center;
					line-height: 40px;
					width: 30px;
					border-right: 1px solid $app-border-color;
					font-size: 12px;
					font-family: $text-font-family;
				}
			}
			.select-wrapper {
				width: 100%;
				font-size: 12px;
			}

			.required {
				display: flex;
				flex-direction: row;
				&:after {
					content: ' *';
					font-weight: 600;
					color: red;
					margin-left: 2px;
				}
			}
		}
		.zip-city-wrapper {
			display: flex;
			> label {
				&:first-child {
					width: 100px;
				}
				:last-child {
					flex-grow: 1;
					margin-left: 15px;
				}
			}
		}
		.zip-error {
			margin-top: -10px;
			text-align: left;
			font-size: 12px;
			padding: 0 0 10px 1px;
			color: $negative-value;
		}
		.vat-error {
			text-align: left;
			font-size: 12px;
			padding: 0 0 10px 1px;
			color: $negative-value;
		}
		.country-vat-wrapper {
			display: flex;
			:first-child {
				flex-grow: 1;
				input {
					height: 35px !important;
				}
			}
			label:last-child {
				width: 200px;
				margin-left: 15px;
			}
			#company_vat {
				padding: 0 16px 0 35px;
			}
		}
		.users-wrapper {
			display: flex;
			label {
				width: 50%;
				> p {
					font-size: 12px;
				}
				.invalid-seats {
					min-height: 14px;
					font-size: 12px;
					color: $negative-value;
				}
				.seat-wrapper {
					display: flex;
					font-size: 12px;
					:first-child {
						margin-right: 20px;
					}
					:last-child {
						align-self: center;
					}
					> input {
						@include input-field;
						padding: 9px 10px;
						font-family: $text-font-family;
						font-weight: $base-font-medium-weight;
						text-align: center;
						border: 1px solid $app-border-color;
						border-radius: 3px;
						width: 50px;
						height: 30px;
						&.invalid {
							border-color: $negative-value;
						}
					}
				}
			}
		}
		.buttons {
			display: flex;
			justify-content: flex-end;
			margin: 0px 0 12px 12px;
			.custom-button-container {
				width: 120px;
				height: 38px;
			}
		}
	}
`;

const SignUpError = styled.div`
	color: red;
	font-size: 10px;
`;

module.exports = {
	SignUpModalStyle,
	SignUpError,
};
